//Förenklad variant
import { useState, useCallback } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Box, Slider } from '@mui/material';
import Cropper from 'react-easy-crop';

function getCroppedImg(image, crop, zoom, aspect = 1, radius = 24) {
  // canvas-export med rundade hörn
  return new Promise((resolve) => {
    const img = new Image();
    img.onload = () => {
      const size = Math.min(img.width, img.height);
      const canvas = document.createElement('canvas');
      canvas.width = size; canvas.height = size;
      const ctx = canvas.getContext('2d');

      // mask med rundade hörn
      ctx.clearRect(0, 0, size, size);
      const r = radius;
      ctx.beginPath();
      ctx.moveTo(r, 0);
      ctx.arcTo(size, 0, size, size, r);
      ctx.arcTo(size, size, 0, size, r);
      ctx.arcTo(0, size, 0, 0, r);
      ctx.arcTo(0, 0, size, 0, r);
      ctx.closePath();
      ctx.save();
      ctx.clip();

      // räkna ut källrektangel utifrån crop/zoom
      const scale = img.naturalWidth / img.width || 1;
      const px = crop.x * scale;
      const py = crop.y * scale;
      const sw = (img.width / zoom) * scale;
      const sh = (img.height / zoom) * scale;

      ctx.drawImage(img, px, py, sw, sh, 0, 0, size, size);
      ctx.restore();

      resolve(canvas.toDataURL('image/png'));
    };
    img.src = image;
  });
}

export default function ImageCropperDialog({ open, src, onClose, onDone }) {
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);

  const handleDone = async () => {
    const out = await getCroppedImg(src, crop, zoom, 1, 24);
    onDone?.(out);
    onClose?.();
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Beskär bild</DialogTitle>
      <DialogContent sx={{ position: 'relative', height: 360 }}>
        <Cropper
          image={src}
          crop={crop}
          zoom={zoom}
          aspect={1}
          onCropChange={setCrop}
          onZoomChange={setZoom}
          cropShape="rect"
          showGrid={false}
          style={{ containerStyle: { borderRadius: 16 } }}
        />
      </DialogContent>
      <DialogActions>
        <Box flex={1} px={2}><Slider min={1} max={3} step={0.01} value={zoom} onChange={(_, v) => setZoom(v)} /></Box>
        <Button onClick={onClose}>Avbryt</Button>
        <Button onClick={handleDone} variant="contained">Spara</Button>
      </DialogActions>
    </Dialog>
  );
}
